import React from 'react'
import createIcon from '@/lib/create-icon'

export const EditSVGIcon = createIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.3333 2.00001C11.5084 1.82491 11.7163 1.68602 11.9451 1.59126C12.1739 1.49651 12.4191 1.44775 12.6667 1.44775C12.9143 1.44775 13.1594 1.49651 13.3883 1.59126C13.6171 1.68602 13.825 1.82491 14 2.00001C14.1751 2.17511 14.314 2.38297 14.4087 2.61182C14.5035 2.84067 14.5522 3.08587 14.5522 3.33334C14.5522 3.58082 14.5035 3.82602 14.4087 4.05487C14.314 4.28372 14.1751 4.49158 14 4.66668L5 13.6667L1.33333 14.6667L2.33333 11L11.3333 2.00001Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
)
